import * as Yup from 'yup';

//types
interface IErrors {
  required: string,
}

function validationSchema(errors: IErrors) {
  return Yup.object().shape({
    date: Yup.date()
      .typeError(errors.required)
      .required(errors.required),
  });
}

export const validationDate = (val: string, errors: IErrors) => {
  const value = { date: val };

  const schema = validationSchema(errors);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
